// Lớp dữ liệu của HANA One. Màn chỉ đọc qua DataSource (qua hook TanStack Query ở react.tsx);
// hôm nay là dữ liệu mẫu, sau đổi sang worker `api` mà không sửa màn.

/** Danh mục thực thể. Mỗi vùng tự khai thêm bằng declaration merging:
 *  declare module '@hana/data' { interface Entities { rate: Rate } } */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface Entities {}
export type EntityKey = keyof Entities & string;

export interface ListQuery {
  /** tìm tự do (bỏ dấu, không phân biệt hoa thường) trên mọi trường chữ */
  q?: string;
  /** lọc bằng: { field: value } */
  where?: Record<string, string | number | boolean>;
  sort?: { field: string; dir?: 'asc' | 'desc' };
  offset?: number;
  limit?: number;
}

export interface Page<T> {
  items: T[];
  total: number;
}

export interface DataSource {
  list<K extends EntityKey>(entity: K, query?: ListQuery): Promise<Page<Entities[K]>>;
  get<K extends EntityKey>(entity: K, id: string): Promise<Entities[K] | null>;
}

export class DataError extends Error {
  constructor(
    public readonly code: 'noperm' | 'notfound' | 'network' | 'unknown',
    message?: string,
  ) {
    super(message ?? code);
  }
}
